<template>
    <div class="ur-data-grid__noti-wrapper">
        <noti-item :noti="noti" v-for="noti in gridInfo.notis" :key="noti.key"/>
    </div>
</template>

<script>
import notiItem from "./urDataGridNotiItem";
export default {
    name : 'urDataGridNoti',
    inject : ['gridInfo'],
    components : {notiItem},
}
</script>

